import * as React from 'react';
import { getModeClass } from 'utils/css';

const ProgressBlockHeader = ({
    title,
    subtitle,
    link,
    onClick,
    shouldInheritStyles
}: IProgressBlockHeader) => {
    const basePageStyleClass = getModeClass('sitegen-friend-referral-progress-block', shouldInheritStyles);
    return (
        <div className={basePageStyleClass}>
            <div className={`${basePageStyleClass}-header__text`}>
                <div className={`${basePageStyleClass}-header__text__title`}>
                    {title}
                </div>
                <div className={`${basePageStyleClass}-header__text__subtitle`}>
                    {subtitle}
                </div>
            </div>
            <div onClick={onClick} className={`${basePageStyleClass}-header__link`}>
                {link}
            </div>
        </div>
    );
};

export interface IProgressBlockHeader {
    readonly title: React.ReactNode;
    readonly subtitle: React.ReactNode;
    readonly link: React.ReactNode;
    readonly onClick: (e: React.SyntheticEvent<HTMLDivElement>) => void;
    readonly shouldInheritStyles: boolean;
}

export default ProgressBlockHeader;
